export default __webpack_public_path__ + "static/media/nDash.da034d83.svg";